import type { ProgressState } from "@/types";
import { createContext, useContext, type ReactNode } from "react";
import type {
  QuestionFlowCompleteExtras,
  QuestionFlowStep,
} from "./elements/question-flow";

export type ReviewQuestionRun = {
  runId: string;
  toolCallId: string;
  steps?: QuestionFlowStep[];
};

type ReviewQuestionContextValue = {
  runs: Record<string, ReviewQuestionRun>;
  answering: boolean;
  submitAnswers: (
    toolCallId: string,
    answers: Record<string, string[]>,
    fallbackRunId?: string,
    extras?: QuestionFlowCompleteExtras
  ) => Promise<void>;
  reviewProgress: ProgressState | null;
  workflowRunId: string | null;
  cancelRunningReview: () => Promise<void>;
  cancellingReview: boolean;
};

const ReviewQuestionContext = createContext<ReviewQuestionContextValue | null>(null);

export function ReviewQuestionProvider({
  value,
  children,
}: {
  value: ReviewQuestionContextValue;
  children: ReactNode;
}) {
  return <ReviewQuestionContext.Provider value={value}>{children}</ReviewQuestionContext.Provider>;
}

export function useReviewQuestion(): ReviewQuestionContextValue {
  const value = useContext(ReviewQuestionContext);
  if (!value) {
    throw new Error("Review questions are only available inside supervisor chat");
  }
  return value;
}
